/* =====================================================================
   LUMEN — Survivors  ::  CONFIG
   Единственный источник правды по балансу и кривым.
   Тюнинг происходит ТОЛЬКО здесь — никакие магические числа в логике.
   ===================================================================== */

// Флаг демо-сборки: vite define (`vite build --mode demo` → true). В тест-бандле/electron без define
// идентификатор не объявлен → typeof даёт 'undefined' → полная версия (безопасный дефолт).
declare const __LUMEN_DEMO__: boolean;
const DEMO_BUILD = (typeof __LUMEN_DEMO__ !== 'undefined') ? __LUMEN_DEMO__ : false;

export const CONFIG: any = {
  // ---- ДЕМО-ГЕЙТИНГ + система билдов ----
  // Демо-сборка (build:demo) ограничивает контент: только Поверхность, два героя/Странник,
  // забег завершается ХУКОМ после 1-го босса (климакс-таста) → экран «полная версия». Гейт идёт
  // через единственный чокпоинт Meta.isUnlocked + Meta.maxDepthAllowed (не дублируется по местам).
  // enabled мутабелен — тесты/Playwright флипают рантайм без пересборки.
  demo: {
    enabled: DEMO_BUILD,
    maxDepth: 0,                                       // демо — только Поверхность (Глубины Тьмы в полной)
    locked: ['umbra', 'mirror', 'ash', 'dawn', 'swarm'], // герои/Пути полной версии (Искра/Уголёк/Странник доступны)
    endAfterBoss: 1,                                   // забег демо завершается хуком после N-го босса
  },

  // ---- Мир / сессия ----
  // Забег БЕСКОНЕЧНЫЙ. dawnTime — веха «Рассвет» (бывший конец на 10:00): засчитывает
  // мету (глубина, win-вехи, рекорд) и даёт право уйти победителем, но игра продолжается
  // в нарастающей «вечной ночи». Забег кончается смертью или добровольным уходом.
  dawnTime: 600,             // секунд до Рассвета (10:00) — веха, не конец
  bossTimes: [300, 570],     // первые боссы: Жнец на 5:00, Затмение на 9:30
  // после bossTimes боссы идут периодически и бесконечно (см. endless.bossEvery)
  endless: {
    bossEvery: 85,           // период боссов после исчерпания bossTimes, сек
    // ступень эскалации после ПОСЛЕДНЕЙ табличной фазы: каждые stepEvery секунд статы врага
    // плавно растут (бесконечная кривая, без новых типов — несущий мотор «вечной ночи»)
    stepEvery: 22,           // длина одной ступени, сек
    hpStep: 0.13,            // +13% hp врага за ступень
    spdStep: 0.008,          // +0.8% скорости за ступень
    dmgStep: 0.05,           // +5% урона за ступень
    capStep: 10,             // +10 к лимиту врагов за ступень
    capMax: 430,             // потолок лимита врагов
    spdCap: 1.7,             // потолок множителя скорости (чтобы не стало неиграбельно)
  },

  // Аномалии — осознанный ВЫБОР на старте забега («Завет тьмы»), а не тихий ролл.
  // Игрок сам решает, какой тьмой обернётся эта ночь → каждый забег различим, есть агентность.
  // false вернёт прежнее поведение (скрытый рандом).
  chooseAnomalies: true,

  // ---- Палитра ПЛАМЯ (PYRE, §10.1): растущий жар против выгоревшего холодного мира.
  // Ядро бело-голубой жар → янтарь → оранж → карминовая граница. «Внешнее» — не чёрное,
  // а остывший уголь (тёмно-серо-синий). Уход от клише «неон на чёрном». ----
  colors: {
    bg:        '#0d0d1a',     // остывший уголь (НЕ чёрный) — у мира низкая, но температура
    grid:      'rgba(150, 120, 110, 0.05)',   // трещины-зола в пепле
    gridBold:  'rgba(190, 150, 120, 0.11)',
    player:    '#ffb02e',     // силуэт пламени — янтарь (= ember-роль)
    playerCore:'#eaf0ff',     // ядро: бело-голубой жар (голубой подсвет = маркер «живости», §10.1)
    xp:        '#ffc266',     // тёплые угольки памяти (опыт)
    xpBig:     '#ffd98a',     // крупный уголёк — НЕ путать с золотом
    gold:      '#ffc83a',     // золото-валюта (редкое) — насыщенно-янтарное
    hp:        '#e0563b',     // ember-red
    hpBack:    'rgba(224,86,59,0.18)',
    xpbar:     '#ffb02e',
    text:      '#f0e6d8',     // тёплый off-white
    textDim:   '#8a7d6e',     // тёплый пепельно-серый (= ash-роль)
    boss:      '#ff6b1a',     // боссы — интенсивный оранж-жар
    danger:    '#d23b2a',     // карминовая граница/угроза (отдельный hue, всегда читается против янтаря)
    dark:      '#0d0d1a',     // цвет выгоревшего «внешнего»
    vow:       '#7a82b5',     // «Завет тьмы»/проклятия — холодный стально-сиреневый (правила остывшего мира, НЕ неон)

    // ---- ГОРНИЛО: температурная иерархия (организующая идея UI — жар кодирует важность). ----
    // Каждый элемент имеет «температуру»: апекс бело-горяч, твои данные янтарь, структура обуглена.
    hot:       '#f6efe3',     // бело-горячий — ОДИН апекс на экране (выбранное / фокус / момент)
    hotBlue:   '#cfe0ff',     // голубой подсвет ядра (живость)
    ember:     '#ffb02e',     // янтарь — ПЕРВИЧНОЕ: твои данные (HUD/билд/активное)
    emberDim:  '#b8742a',     // тлеющий — вторичный янтарь (неактивное/подписи/прошедшее)
    char:      '#15110c',     // обугленное — фон плит / структура
    char0:     '#0a0908',     // самое тёмное — провалы / мёртвый мир
    ash:       '#8a7d6e',     // пепельный — нейтральный readout-текст
    // регистр ГИБРИД (владелец): тёплый горн в меню → остывает к геймплею.
    warmBg:    '#1a1208',     // тёплый угольно-янтарный фон (меню/кузница)
    coldBg:    '#0b0c12',     // холодный остывший уголь (геймплей/пепелище)
    plateHi:   'rgba(246,239,227,0.13)',   // верхняя фаска плиты (ловит бело-горячий свет)
    plateLo:   'rgba(0,0,0,0.55)',         // нижняя фаска (обуглена)
  },

  // ---- Твист: СВЕТ. Игрок = источник света, тьма наступает с краёв.
  // Радиус света растёт с уровнем (Хаос→Порядок), проседает при уроне.
  // Враги во тьме быстрее (рвутся из теней) и нормальны в свете. ----
  light: {
    base: 250,            // стартовый радиус света (видно ближний рой)
    perLevel: 16,         // прирост за уровень
    max: 540,             // потолок
    min: 120,             // не уходит ниже (всегда видно угрозу рядом)
    hitLoss: 55,          // на сколько тьма наступает при ударе
    recover: 75,          // восстановление света, px/сек
    darkSpeedMult: 1.35,  // ускорение врагов вне света
    darkSpeedMultLo: 1.2, // …для взявшего тёмный полюс (loEdge>0): «тьма признаёт своего» — полюс остаётся жизнеспособным
    // HG-9: ЖАР СВЕТА — лит-зона есть твоё пламя; враги внутри радиуса горят, урон ∝ силе света
    // (lightFrac = light/max). Делает ось «ты=свет» ЖИВЫМ оружием (свет-билд → поле-killzone),
    // а не декоративной. Боссы иммунны (флэт-dps их не должен тривиализировать). Тюнить здесь.
    heatDps: 9,           // урон/сек врагу в свете при ПОЛНОМ радиусе (×lightFrac на деле)
    // HG-11 (фикс Сценария C): killzone-жар — ПОДПИСЬ светлого полюса, не бесплатный профит нейтрали.
    // Базовый heatDps есть у всех (идентичность «ты=свет»), но СИЛЬНОЕ поле-killzone даёт только
    // светлый завет (hiEdge): множитель урона жара = 1 + heatEdgeAmp×hiEdge. Нейтраль с большим
    // радиусом покрывает многих, но жжёт слабо — чтобы расти полюсно, надо ВЫБРАТЬ Венец зари.
    heatEdgeAmp: 1.7,
    // OGD-фикс хрупкости тёмного полюса: РАННЯЯ выплата loEdge. Без пола тёмный билд при ВЫСОКОМ свете
    // (первые ~90с, до нырка) почти не усилен и гибнет до роя ф.2, не узнав что полюс работает («порог
    // без плато накопления»). loFloor = доля бонуса, что даётся СРАЗУ за коммит в тёмный (умбралвард/завет),
    // остаток масштабируется нырком. Тёмный бьёт ощутимо с порога → переживает ранний экзамен. Светлый
    // floor НЕ нужен (он и так снежноком). Магнитуда — тюнинг-ручка.
    loFloor: 0.35,
    glintRadius: 3,       // размер точки-глинта врага/осколка во тьме (читаемость)
    glintAlpha: 0.6,      // яркость глинта
    shotGlintAlpha: 0.8,  // яркость глинта вражеского снаряда (виднее — уклоняться)
    // врагов во тьме НЕ видно — лишь редкие вспышки-молнии выхватывают их силуэты,
    // а на кромке тлеет «пульс угрозы» (чувствуешь рой, но не видишь где)
    flashPeriod: 4.0,     // период вспышки, сек
    flashDur: 0.42,       // длительность вспышки, сек (дольше → читается как волна света, не глитч)
    threatRange: 200,     // на сколько за кромкой света считаем «угрозу рядом»
  },

  /* ---------------------------------------------------------------
     ВЫЖЖЕННАЯ ЗЕМЛЯ (память формы) — несущая идея «Пепелища»: огонь = память формы,
     рост = расширяешь область где форму помнят. Где прошло твоё горячее ядро, мир
     «помнит форму» — остаётся тёплая территория, в которой остывший рой СЛАБЕЕ
     (замедляется и медленно тлеет). Это делает экспансию пространственной: ты не
     обороняешь точку, а ЗАХВАТЫВАЕШЬ карту, оставляя за собой выжженный след.
     Метки следа кладутся по пути игрока (кольцевой буфер), живут life секунд.
     Боссы иммунны к тлению (чтобы след не тривиализировал бой), но замедление их берёт.
     --------------------------------------------------------------- */
  emberField: {
    emitDist: 46,   // px пути ядра между метками следа
    maxMarks: 12,   // потолок активных меток (кольцевой буфер; держит перф и читаемость)
    radius: 50,     // радиус зоны влияния метки (след-территория)
    life: 6,        // сек жизни метки (память выветривается)
    // Тление — несущий эффект: холодный рой в твоей территории медленно РАСТВОРЯЕТСЯ в память
    // формы (= XP). Это и про-прогрессия (килл→опыт), и harness-стабильно (не двигает позиции,
    // нет каскада пути бота), и точно по лору. Боссы иммунны (след не тривиализирует бой).
    dotPct: 0.04,   // доля макс. HP врага/сек — мягко, выверено harness (кривая сложности залочена)
    // Замедление врага в зоне: 1.0 = выкл. Намеренно ВЫКЛ — замедление анти-прогрессия (тормозит
    // приток врагов под удар → проседает темп опыта, harness ловит) и брит-каскадит путь бота.
    // Оставлено рычагом глазу Дмитрия: <1 вернёт «вязкую» территорию, если захочет тактильнее.
    slow: 1.0,
    // СИНЕРГИЯ D2 (тёмный билд контролирует пространство): в ПЛОТНОЙ своей территории (где метки
    // перекрываются — там кружил/держал позицию, визуально ярче светится) loEdge-урон усилен.
    // Бонус за каждую перекрывающую игрока зону сверх первой, до synergyCap зон.
    loSynergy: 0.2,
    synergyCap: 3,
  },

  // ---- Игрок (базовые статы; модифицируются пассивками) ----
  player: {
    radius: 14,
    maxHp: 100,
    moveSpeed: 178,        // px/сек (215→178: запас над роем падает с +68% до +39% — уворот требует манёвра, не прямой; «тяжесть» тела с первой минуты)
    pickupRadius: 90,      // радиус магнита (снижен 140→90: движение к добыче снова имеет смысл)
    regen: 0,              // hp/сек (растёт пассивкой)
    iframes: 0.5,          // неуязвимость после удара, сек
    damageMult: 1,
    contactKnockback: 220, // насколько игрок отталкивает врага при контакте
  },

  // ---- Кривая опыта ----
  xp: {
    base: 9,               // XP до 2 уровня (7→9: ранние апгрейды реже — апгрейд снова событие, не поток)
    growth: 1.42,          // множитель на уровень (1.36→1.42: разряжает спам-окно 1–4 мин, где плотность врагов обгоняла кривую)
    gemValue: 1,           // обычный осколок
    gemBigValue: 5,        // крупный осколок (с танков/боссов)
    gemLife: 22,           // сек: заброшенный далеко во тьме осколок опыта остывает и гаснет — declutter дальнего клаттера
    gemFarBuffer: 300,     // px за кромкой света, дальше которого опыт начинает остывать (у кромки/в свете — не теряется)
    dropChance: 0.6,       // шанс, что убитый враг вообще роняет опыт (боссы — всегда, см. game.ts)
  },

  // ---- глобальные ручки баланса ----
  balance: {
    weaponDmg: 1,        // общий множитель урона ВСЕГО оружия
  },

  /* ---------------------------------------------------------------
     КРИВАЯ ЭСКАЛАЦИИ — несущий параметр Хаос→Порядок.
     Каждая фаза активна с tStart (сек). Берётся последняя подходящая.
     spawnInterval — пауза между волнами спавна (сек)
     batch        — сколько врагов за одну волну
     cap          — максимум врагов на экране
     hpMult/spdMult/dmgMult — масштаб статов врага в этой фазе
     weights      — вероятностные веса по типам врага
     --------------------------------------------------------------- */
  // Кривая вводит НОВЫЕ механики по одной за фазу (не стеком): мягкая кривая обучения.
  // splitter@150 → spitter/ranged@240 → devourer/drain@300 → leech+anchor@375 → brute@460.
  phases: [
    { tStart: 0,   spawnInterval: 0.85, batch: 1, cap: 30,  hpMult: 1.0, spdMult: 1.0, dmgMult: 1.0,
      weights: { chaser: 1 } },
    { tStart: 60,  spawnInterval: 0.55, batch: 2, cap: 70,  hpMult: 1.25, spdMult: 1.05, dmgMult: 1.0,
      weights: { chaser: 3, swarm: 2 } },
    { tStart: 150, spawnInterval: 0.42, batch: 3, cap: 110, hpMult: 1.7, spdMult: 1.1, dmgMult: 1.1,
      weights: { chaser: 3, swarm: 3, tank: 1, splitter: 1 } },
    { tStart: 240, spawnInterval: 0.34, batch: 4, cap: 150, hpMult: 2.3, spdMult: 1.15, dmgMult: 1.2,
      weights: { chaser: 3, swarm: 4, tank: 2, splitter: 2, spitter: 1 } },                       // дальник
    { tStart: 300, spawnInterval: 0.30, batch: 4, cap: 185, hpMult: 2.9, spdMult: 1.18, dmgMult: 1.28,
      weights: { chaser: 3, swarm: 4, tank: 2, splitter: 2, spitter: 2, devourer: 1, sniper: 1 } },  // высасывание света + дальнобой-снайпер (контр светлого)
    { tStart: 375, spawnInterval: 0.26, batch: 5, cap: 215, hpMult: 3.6, spdMult: 1.21, dmgMult: 1.36,
      weights: { chaser: 2, swarm: 5, tank: 3, spitter: 2, splitter: 2, devourer: 1, leech: 1, anchor: 1, sniper: 1, diver: 1 } }, // подавление + пятна + срыв (контр тёмного)
    { tStart: 460, spawnInterval: 0.22, batch: 6, cap: 260, hpMult: 4.8, spdMult: 1.25, dmgMult: 1.5,
      weights: { chaser: 2, swarm: 5, tank: 4, spitter: 3, splitter: 3, devourer: 2, anchor: 2, leech: 2, brute: 2, sniper: 2, diver: 2 } },
  ],

  /* ---------------------------------------------------------------
     ГЛУБИНЫ ТЬМЫ — ascension-лестница. depth 0 = базовый забег.
     depth N>=1 берёт depths[N-1]: стек модификаторов поверх фаз.
     Открывается победой на предыдущей глубине. Несущий мотор «ещё забег».
     --------------------------------------------------------------- */
  depths: [
    // forceAnomaly: глубина НЕСЁТ свою тематическую аномалию всегда (характер места,
    // не просто +числа). Она занимает один слот в общем числе аномалий — игрок
    // выбирает остальные (см. Game.anomalyCount / openAnomalyDraft). Глубины I–II без
    // форса (там выбор полностью за игроком); с III тьма начинает диктовать свой нрав.
    { name: 'Глубина I',   hp: 1.30, spd: 1.04, dmg: 1.10, light: 0.94, reward: 1.35, desc: 'Холод гуще. Жар слабее.' },
    { name: 'Глубина II',  hp: 1.70, spd: 1.08, dmg: 1.20, light: 0.88, reward: 1.75, desc: 'Враги крепче, ночь ближе.' },
    { name: 'Глубина III', hp: 2.20, spd: 1.12, dmg: 1.32, light: 0.82, reward: 2.20, desc: 'Жар едва держится.',      forceAnomaly: 'longnight' },
    { name: 'Глубина IV',  hp: 2.90, spd: 1.16, dmg: 1.46, light: 0.76, reward: 2.80, desc: 'Бездна смотрит в ответ.', forceAnomaly: 'famine' },
    { name: 'Глубина V',   hp: 3.80, spd: 1.20, dmg: 1.62, light: 0.70, reward: 3.60, desc: 'Только рассвет спасёт.',  forceAnomaly: 'swarmtide' },
    { name: 'Глубина VI',  hp: 5.00, spd: 1.25, dmg: 1.80, light: 0.64, reward: 4.60, desc: 'Конец тепла.',           forceAnomaly: 'twilight' },
  ],

  /* ---------------------------------------------------------------
     АНОМАЛИИ ТЬМЫ — модификаторы правил. Игрок ВЫБИРАЕТ их на старте
     («Завет тьмы», см. Game.openAnomalyDraft), либо они роллятся скрытно
     (chooseAnomalies=false, Game.applyRolledAnomalies). Делают каждый забег
     непохожим. Применяются множителями к системам. Число растёт с глубиной
     (Game.anomalyCount); часть может быть навязана глубиной (depths.forceAnomaly).
     --------------------------------------------------------------- */
  anomalies: [
    { key: 'twilight',  name: 'Сумрак',        desc: 'Радиус жара −22%',                     icon: '◑', light: 0.78 },
    { key: 'longnight', name: 'Долгая ночь',   desc: 'Удар сильнее гасит жар',               icon: '☾', hitLoss: 1.7, recover: 0.8 },
    { key: 'swarmtide', name: 'Прилив роя',    desc: 'Вдвое больше мелких тварей',           icon: '∴', weightMul: { swarm: 2.6, splitter: 1.8 } },
    { key: 'frenzy',    name: 'Неистовство',   desc: 'Враги быстрее, но золота больше',      icon: '⚡', enemySpd: 1.16, reward: 1.4 },
    { key: 'gloom',     name: 'Морок',         desc: 'Магнит слабее, зато опыт жирнее',      icon: '◍', pickup: 0.65, xp: 1.5 },
    { key: 'embertide', name: 'Раздув',        desc: 'Жар растёт быстрее, но холод давит',   icon: '✸', recover: 1.6, darkSpeed: 1.22 },
    { key: 'famine',    name: 'Голод',         desc: 'Тьма плодит крупных тварей',           icon: '◆', weightMul: { devourer: 3, anchor: 2.4 } },
    { key: 'fragile',   name: 'Хрупкость',     desc: 'Враги бьют больнее, но мрут легче',    icon: '✕', enemyHp: 0.7, enemyDmg: 1.35, reward: 1.3 },
    // ЗАВЕТ ПЕПЛА — опт-ин билд-ось Границы: жертвуешь радиусом жара ради ярости во тьме (малое горячее ядро = риск/мощь)
    { key: 'embervow',  name: 'Завет пепла',   desc: 'Жар сжат, но во тьме ярость растёт',   icon: '†', light: 0.82, loEdge: 0.7 },
  ],

  // ---- Маятник День/Ночь: радиус света дышит, частота растёт к финалу ----
  // hiSynergy: синергия СВЕТЛОГО полюса билд-оси — на ПИКЕ качания (ярче всего) hiEdge-урон
  // усилен (окна burst по ритму). Награда светлого билда за игру по маятнику. 0 = выкл.
  cycle: { period: 96, periodEnd: 46, swing: 0.13, hiSynergy: 0.5 },

  /* ---------------------------------------------------------------
     СОБЫТИЯ ТЬМЫ — развилка-выбор без правильного ответа (на таймере).
     Переиспользует UI драфта. Каждый выбор — характерный риск/награда.
     --------------------------------------------------------------- */
  eventTimes: [205, 415],   // 3:25 и 6:55 — между боссами, не в их момент (ранний забег)
  eventEvery: 80,           // после eventTimes — развилка каждые N сек в вечной ночи (поток не плоский)
  heattide: { dmg: 1.5, life: 14 },   // «Прилив жара»: ×урон и длительность окна бафа
  darkEvents: [
    { kind: 'eliteWave', icon: '⚔', color: '#d0563b', name: 'Прорыв теней',  desc: 'Волна крепких тварей разом — но щедрый дождь золота' },
    { kind: 'curse',     icon: '☾', color: '#7a82b5', name: 'Сгущение тьмы', desc: 'Новое тёмное правило до конца забега — взамен +15% урона навсегда' },
    { kind: 'respite',   icon: '✚', color: '#7CFFB2', name: 'Затишье',       desc: 'Развеять ближний холод, +50% HP, жар вспыхнёт' },
    { kind: 'fortune',   icon: '◆', color: '#ffd24a', name: 'Россыпь',       desc: 'Богатый дождь золота и немного здоровья' },
    { kind: 'heattide',  icon: '✸', color: '#ff7a2a', name: 'Прилив жара',   desc: 'Жар вскипает: ×1.5 урона на время и вспышка радиуса' },
    { kind: 'rift',      icon: '◈', color: '#ffd98a', name: 'Раскол',        desc: 'Роняет реликвию — но трещина впускает холод' },
  ],

  // ---- Разблокировки: контент за вехами. Питает «ещё забег» (мета-петля) ----
  // cond: { survive, level, totalKills, killBoss, win, depth } — любое из условий.
  unlocks: [
    { key: 'beam',      kind: 'weapon', cond: { survive: 240 },      hint: 'Доживи до 4:00' },
    { key: 'lantern',   kind: 'weapon', cond: { killBoss: true },    hint: 'Срази первого босса' },
    { key: 'duskblade', kind: 'weapon', cond: { totalKills: 1500 },  hint: 'Убей 1500 тварей (всего)' },
    { key: 'ricochet',  kind: 'weapon', cond: { level: 14 },         hint: 'Достигни 14 уровня в забеге' },
    { key: 'dawnflash', kind: 'weapon', cond: { win: true },         hint: 'Достигни Рассвета (10:00)' },
    { key: 'umbra',     kind: 'char',   cond: { killBoss: true },    hint: 'Срази босса' },
    { key: 'mirror',    kind: 'char',   cond: { depth: 1 },          hint: 'Войди в Глубину Тьмы' },
    // ПУТИ (мета-способы) — открываются вехами; wanderer всегда доступен (не в списке)
    { key: 'ash',       kind: 'path',   cond: { killBoss: true },    hint: 'Срази первого босса' },
    { key: 'swarm',     kind: 'path',   cond: { totalKills: 2000 },  hint: 'Убей 2000 тварей (всего)' },
    { key: 'dawn',      kind: 'path',   cond: { win: true },         hint: 'Достигни Рассвета (10:00)' },
    // ПРОГРЕССИВНОЕ РАСКРЫТИЕ СИСТЕМ (онбординг по OGD): забег 1 чистый, системы раскрываются по 1 за
    // забег как маркированные Качественные Пороги. cond.totalRuns — число сыгранных забегов. hint = обучение
    // (показывается на экране итогов, когда система раскрылась). Кадэнс: лёгкие быстро, заветы с зазором-плато.
    { key: 'shrines',   kind: 'reveal', cond: { totalRuns: 1 },      hint: 'Открыто: Святилища — маяки вдали хранят реликвии, дойди до них' },
    { key: 'events',    kind: 'reveal', cond: { totalRuns: 2 },      hint: 'Открыто: Развилки Тьмы — выбор-риск без правильного ответа' },
    { key: 'anomalies', kind: 'reveal', cond: { totalRuns: 4 },      hint: 'Открыто: Завет тьмы — выбери, какой тьмой обернётся забег' },
  ],

  // ---- Типы врагов ----
  enemies: {
    chaser: {
      name: 'Тень', radius: 13, hp: 10, speed: 70, damage: 8,
      color: '#6f9ad8', shape: 'shard', xp: 1, score: 1,        // стальной голубой — рядовой
    },
    swarm: {
      name: 'Морок', radius: 9, hp: 5, speed: 128, damage: 5,
      color: '#5fd6e8', shape: 'shard', xp: 1, score: 1,        // ледяной циан — быстрый рой
    },
    tank: {
      name: 'Гнёт', radius: 22, hp: 70, speed: 42, damage: 16,
      color: '#5a64b4', shape: 'block', xp: 5, bigGem: true, score: 3,   // индиго-сталь — массивный
    },
    spitter: {
      name: 'Плевун', radius: 14, hp: 24, speed: 46, damage: 6,
      color: '#4fc8a8', shape: 'streak', xp: 2, score: 2,       // морозная бирюза — дальник
      ranged: true, shotDmg: 6, shotSpeed: 235, shotCd: 2.8, shotRange: 430, shotRadius: 6,
    },
    // Пожиратель: пока жив и близко — высасывает твой радиус света (приоритет «убить первым»)
    devourer: {
      name: 'Пожиратель', radius: 19, hp: 58, speed: 50, damage: 12,
      color: '#a76fd0', shape: 'block', xp: 4, bigGem: true, score: 4,   // холодный аметист — сосёт свет
      drainLight: 46, drainRange: 230,
    },
    // Дробитель: при смерти распадается на 3 быстрых Осколка (дилемма «где убивать»)
    splitter: {
      name: 'Дробитель', radius: 16, hp: 34, speed: 66, damage: 10,
      color: '#8a82e6', shape: 'shard', xp: 2, score: 2,        // сине-индиго — распадается
      split: 'splitling', splitCount: 3,
    },
    // Осколок: дочерний враг Дробителя (не спавнится волнами, только при разделении)
    splitling: {
      name: 'Осколок', radius: 9, hp: 8, speed: 104, damage: 6,
      color: '#a6e2ec', shape: 'shard', xp: 1, score: 1,        // бледный циан — дочерний осколок
    },
    // Якорь: при смерти роняет пятно тьмы, гасящее рост света на участке (геометрия тьмы)
    anchor: {
      name: 'Якорь', radius: 20, hp: 82, speed: 30, damage: 14,
      color: '#4d7ae0', shape: 'block', xp: 5, bigGem: true, score: 5,   // электрик-синий — роняет тьму
      anchorOnDeath: true, anchorRadius: 150, anchorLife: 9,
    },
    // Рассеиватель: аура глушит ВОССТАНОВЛЕНИЕ света, пока рядом (тьма не отступает)
    leech: {
      name: 'Рассеиватель', radius: 15, hp: 40, speed: 58, damage: 8,
      color: '#3fb4cc', shape: 'streak', xp: 3, score: 3,       // тил-циан — глушит восстановление
      suppressLight: true, suppressRange: 210,
    },
    // Громада: тяжёлый бугай поздних фаз/глубин — давит массой
    brute: {
      name: 'Громада', radius: 28, hp: 160, speed: 36, damage: 22,
      color: '#6878c4', shape: 'block', xp: 8, bigGem: true, score: 8,   // сланцево-синий — тяжёлый бугай
    },
    // HG-10 КОНТР-ВРАГ ТЁМНОГО ПОЛЮСА. Срыв: холод-смертник — ИГНОРИРУЕТ жар (heatImmune),
    // поле-killzone его не берёт. Рвётся рывками в упор (lunge). Кто живёт широким светлым полем,
    // не успевает его сжечь — нужен burst оружия в упор (loEdge тёмного билда). Уязвим к выжженной
    // земле (тёмный инструмент) — асимметрия: свет-поле мимо, пепел-поле бьёт.
    diver: {
      name: 'Срыв', radius: 12, hp: 30, speed: 92, damage: 18,
      color: '#c75b6a', shape: 'shard', xp: 2, score: 3,        // холодный багрянец — «иной, опасный»
      heatImmune: true, lunge: true, lungeRange: 300, lungeSpeed: 520, lungeCd: 2.2,
    },
    // HG-10 КОНТР-ВРАГ СВЕТЛОГО ПОЛЮСА. Жало: дальнобой, держит дистанцию и ПЯТИТСЯ (kite).
    // Достать можно только широким жаром: дальность Импульса = радиус света, killzone тоже.
    // Малое горячее ядро (тёмный билд) до него не дотянется, не выйдя на открытое — приходится
    // ловить светлым полем. Зеркало Срыва.
    sniper: {
      name: 'Жало', radius: 13, hp: 30, speed: 72, damage: 6,
      color: '#6fd0c0', shape: 'streak', xp: 3, bigGem: true, score: 4,
      ranged: true, shotDmg: 11, shotSpeed: 300, shotCd: 2.4, shotRange: 560, shotRadius: 7,
      kite: true, kiteRange: 320,
    },
    // ВТОРЫЕ ФАЗЫ (phase2): при низком HP босс обретает НОВЫЙ примитив (рекомбинация из арсенала
    // других врагов) — бой эскалирует, босс «читает» билд. atHp — доля HP-порога входа во 2-ю фазу.
    // Разъярённый босс к тому же быстрее при ВЫСОКОМ свете игрока (полюс-чтение: давит светлый билд).
    boss: {
      name: 'Жнец', radius: 48, hp: 1900, speed: 58, damage: 28,
      color: '#d0563b', shape: 'vortex', xp: 40, bigGem: true, score: 50,   // вихрь пепла — читается издали
      isBoss: true, phase2: { atHp: 0.5, lunge: { range: 380, speed: 470, cd: 2.6 } },   // в ярости — бросается в упор
    },
    boss2: {
      name: 'Затмение', radius: 56, hp: 6000, speed: 50, damage: 36,
      color: '#c04830', shape: 'vortex', xp: 70, bigGem: true, score: 90,
      isBoss: true, phase2: { atHp: 0.4, drain: { light: 70, range: 340 } },   // в ярости начинает сосать свет
    },
    // Владыка Затмения: аура постоянно высасывает твой свет, при смерти роняет якори
    boss3: {
      name: 'Владыка Затмения', radius: 54, hp: 9000, speed: 54, damage: 34,
      color: '#b83a2e', shape: 'vortex', xp: 90, bigGem: true, score: 110,
      isBoss: true, drainLight: 60, drainRange: 380,
      anchorOnDeath: true, anchorRadius: 230, anchorLife: 7,
      phase2: { atHp: 0.35, slam: { radius: 205, dmg: 34, cd: 4.0 } },   // в ярости — слэм по площади
    },
    // Нулевая Точка: пульсирует кольцами тьмы — радиальные залпы по таймеру
    boss4: {
      name: 'Нулевая Точка', radius: 50, hp: 11000, speed: 30, damage: 30,
      color: '#a82e26', shape: 'vortex', xp: 110, bigGem: true, score: 140,
      isBoss: true, ring: true, ringCd: 3.2, ringShots: 14, ringSpeed: 205, ringDmg: 14, ringRadius: 7,
      phase2: { atHp: 0.4, ringRush: { cdMul: 0.55, shotsAdd: 6 } },   // в ярости — кольца чаще и гуще
    },
    // Исполин: ГИГАНТ на пол-экрана. Медленно, но неотвратимо преследует (резинка догоняет за кромкой).
    // Не уйти шагом — только кайтить по дуге. Периодический СЛЭМ: телеграф-кольцо (красное, растёт),
    // затем удар по площади + откидывает рой. Туша перекрывает обзор — заставляет двигаться, не стоять.
    boss5: {
      name: 'Исполин', radius: 132, hp: 16000, speed: 47, damage: 46,
      color: '#9a3528', shape: 'vortex', xp: 130, bigGem: true, score: 170,
      isBoss: true, slam: true, slamCd: 4.5, slamRadius: 235, slamDmg: 40,
    },
  },

  // ---- Персонажи: разный старт и статы (выбор перед забегом) ----
  // shape — форма-силуэт героя (в палитре света/огня), различает их визуально
  characters: {
    spark: {
      name: 'Искра', desc: 'Равновесие во всём. Старт: Импульс.',
      icon: '✦', color: '#ffb830', shape: 'diamond', start: 'bolt', mods: {},
    },
    ember: {
      name: 'Уголёк', desc: 'Стекло-пушка: +25% урона, но меньше HP и жара. Старт: Импульс.',
      icon: '✺', color: '#ff6b1a', shape: 'tri', start: 'bolt',
      mods: { damageMult: 1.25, moveSpeedMul: 1.05, maxHp: 72, lightBonus: -40 },
    },
    // Угасающий: горит ярко, но недолго. Свет тает со временем, каждый убитый — ещё миг света.
    umbra: {
      name: 'Тлеющий', desc: 'Горит ярко, но недолго: жар тает, каждый убитый — ещё миг. Старт: Импульс.',
      icon: '☄', color: '#ff8c3a', shape: 'hex', start: 'bolt',
      mods: { lightMode: 'decay', lightDecay: 7, killLight: 4, damageMult: 1.12 },
    },
    // Зеркало: свет только из осколков убийств; урон бьёт по ним. Агрессия — единственный путь.
    mirror: {
      name: 'Обращённый', desc: 'Жар рождается из убийств; урон гасит накопленное. Старт: Жар-сфера.',
      icon: '◇', color: '#ffe2b0', shape: 'circle', start: 'orbit',
      mods: { lightMode: 'mirror', mirrorPer: 22, moveSpeedMul: 1.05 },
    },
  },

  /* ---------------------------------------------------------------
     ПУТИ — мета-как-СПОСОБЫ: разблокируемые вехами стартовые архетипы-идентичности,
     выбираются пред-забегом ТРЕТЬЕЙ осью в charselect (рядом с глубиной). Горизонтальная
     идентичность на МЕТА-уровне («кто ты сегодня»), поверх героя. НЕ новая мехсистема —
     применяются через СУЩЕСТВУЮЩУЮ машинерию: startCovenant вливается в computeRunMods как
     форс-аномалия (как depth.forceAnomaly), startWeapon/Passive/Relic — через addWeapon/
     addPassive/applyRelic в start(). Новый Путь = запись данных здесь (+ i18n + анлок).
     Path[0] всегда открыт (ванильный старт). Синергия с билд-осью Границы.
     --------------------------------------------------------------- */
  paths: [
    { key: 'wanderer', name: 'Странник',   desc: 'Обычное начало — путь открыт, завета нет.',                   icon: '○', color: '#9a8f80' },
    { key: 'ash',      name: 'Путь Пепла', desc: 'Тёмный билд с порога: старт под Заветом пепла и Яростью углей.', icon: '†', color: '#b5683a', startCovenant: 'embervow', startRelic: 'umbralward' },
    { key: 'dawn',     name: 'Путь Зари',  desc: 'Светлый билд с порога: старт с Венцом зари и стойким жаром.',     icon: '☀', color: '#ffd98a', startRelic: 'dawncrown', startPassive: 'regen' },
    { key: 'swarm',    name: 'Путь Роя',   desc: 'Против массы: старт с Перекатом огня и Магнитом.',               icon: '∴', color: '#9fd8ff', startWeapon: 'chain', startPassive: 'magnet' },
  ],

  // ---- Магазин: перманентные апгрейды за золото (localStorage) ----
  // Два трека (OGD: разные скорости/типы отдачи): track:'forge' КУЗНИЦА — статы (короткий, быстрый кап,
  // «входной порог»); track:'hearth' ГОРНИЛО — ГОРИЗОНТАЛЬ (агентность/выбор/исследование, НЕ сырая сила —
  // иначе мета съест моат-ось). Длинный трек = «есть что тратить» без grind-wall. Всё через Meta.upgLevel
  // в computeRunMods/старте — без нового стейта/экрана.
  shop: [
    { key: 'maxhp',  name: 'Закалка',        desc: '+12 макс. HP за уровень',  icon: '❤', color: '#ff4d6d', max: 5, cost: [40, 70, 110, 160, 230], track: 'forge' },
    { key: 'power',  name: 'Ярость',         desc: '+5% урона за уровень',      icon: '✸', color: '#ff7a5c', max: 5, cost: [50, 90, 140, 210, 300], track: 'forge' },
    { key: 'speed',  name: 'Прыть',          desc: '+4% скорости за уровень',   icon: '➤', color: '#5ef2ff', max: 5, cost: [45, 80, 130, 190, 270], track: 'forge' },
    { key: 'light',  name: 'Сияние',         desc: '+20 жара за уровень',       icon: '☀', color: '#ffce5e', max: 5, cost: [40, 75, 120, 180, 260], track: 'forge' },
    { key: 'revive', name: 'Второе дыхание', desc: 'Восстать при гибели (раз)', icon: '✚', color: '#7CFFB2', max: 2, cost: [220, 600], track: 'forge' },
    // ГОРНИЛО — горизонталь: меняет КАК играешь, не множит силу (читается в game.ts по Meta.upgLevel)
    { key: 'reroll', name: 'Лишний уголь',   desc: '+1 пересбор драфта за забег', icon: '↻', color: '#9fd8ff', max: 2, cost: [130, 320], track: 'hearth' },
    { key: 'beacons',name: 'Память святилищ',desc: 'Святилища горят чаще',        icon: '✦', color: '#ffe066', max: 3, cost: [90, 170, 280], track: 'hearth' },
    { key: 'trove',  name: 'Реликварий',     desc: '+1 реликвия в выборе святилищ', icon: '◆', color: '#ffd24a', max: 1, cost: [240], track: 'hearth' },
    { key: 'anoma',  name: 'Кузня аномалий', desc: '+1 выбор Завета тьмы на старте', icon: '☾', color: '#b39ddb', max: 2, cost: [200, 420], track: 'hearth' },
  ],

  // ---- Оружие (lvl 1..5; stats масштабируются по уровню) ----
  // dmg/cooldown/count и т.п. — массивы по уровням (индекс = lvl-1)
  weapons: {
    bolt: {
      name: 'Импульс', desc: 'Сгусток жара бьёт в ближайшего — только в зоне света',
      icon: '✦', color: '#ffb030', kind: 'bolt',
      cooldown: [0.90, 0.80, 0.70, 0.60, 0.50],
      dmg:      [9, 12, 15, 19, 24],
      count:    [1, 1, 2, 2, 3],
      speed: 340, pierce: 0, radius: 5, life: 1.2, knockback: 90,
      lightGated: true,        // бьёт только по освещённым целям (дальность = радиус света)
      evolveWith: 'power', evolveInto: 'dawnray',
    },
    orbit: {
      name: 'Жар-сфера', desc: 'Сгустки жара вращаются вокруг тебя',
      icon: '◌', color: '#ffb35c', kind: 'orbit',
      cooldown: [0, 0, 0, 0, 0],
      dmg:      [6, 8, 11, 14, 18],
      count:    [2, 2, 3, 3, 4],
      orbitRadius: 64, orbitSpeed: 2.6, radius: 11, tick: 0.25, knockback: 60,
      evolveWith: 'magnet', evolveInto: 'corona',
    },
    nova: {
      name: 'Вспышка', desc: 'Взрывная волна жара вокруг тебя',
      icon: '✺', color: '#ff6b1a', kind: 'nova',
      cooldown: [2.6, 2.3, 2.0, 1.7, 1.4],
      dmg:      [12, 17, 23, 30, 40],
      count:    [1, 1, 1, 1, 1],
      novaRadius: [95, 115, 135, 155, 185], knockback: 260,
      evolveWith: 'vigor', evolveInto: 'supernova',
    },
    whip: {
      name: 'Хлыст', desc: 'Рассекающий удар по направлению движения',
      icon: '⟿', color: '#ffd24a', kind: 'whip',
      cooldown: [1.0, 0.88, 0.74, 0.60, 0.46],
      dmg:      [14, 19, 25, 33, 44],
      count:    [1, 1, 2, 2, 2],
      whipLen: [150, 165, 180, 200, 230], whipWide: 46, knockback: 140,
      evolveWith: 'speed', evolveInto: 'solaredge',
    },
    chain: {
      name: 'Перекат огня', desc: 'Огонь перекидывается между врагами',
      icon: '⚡', color: '#9fd8ff', kind: 'chain',
      cooldown: [1.1, 0.98, 0.85, 0.72, 0.6],
      dmg:      [10, 13, 17, 22, 28],
      count:    [2, 3, 3, 4, 5],          // число прыжков
      hopRange: 175, firstRange: 340, knockback: 40,
      evolveWith: 'regen', evolveInto: 'tempest',
    },
    mine: {
      name: 'Уголь', desc: 'Тлеющий уголь вспыхивает у ног врага',
      icon: '✲', color: '#ffd27a', kind: 'mine',
      cooldown: [2.0, 1.8, 1.6, 1.4, 1.2],
      dmg:      [18, 24, 31, 40, 52],
      count:    [1, 1, 2, 2, 3],          // мин за раз
      mineRadius: 72, mineLife: 6, mineTrigger: 46, knockback: 210,
      evolveWith: 'magnet', evolveInto: 'beacon',
    },
    // Жаролуч: постоянный жгущий поток в сторону взгляда — оружие и источник тепла разом
    beam: {
      name: 'Жаролуч', desc: 'Постоянный жгущий поток в сторону взгляда',
      icon: '⌖', color: '#fff0a0', kind: 'beam',
      cooldown: [0, 0, 0, 0, 0],
      dmg:      [5, 7, 9, 12, 16],         // урон за тик
      count:    [1, 1, 1, 1, 2],           // число лучей
      beamLen: [220, 250, 285, 320, 360], beamWide: 9, tick: 0.12, knockback: 28,
      evolveWith: 'power', evolveInto: 'sunlance',
    },
    // Горнило: ставит зону жара — замедляет тварей и жжёт их
    lantern: {
      name: 'Горнило', desc: 'Ставит зону жара: тормозит и жжёт тварей',
      icon: '☼', color: '#ffd27a', kind: 'lantern',
      cooldown: [3.2, 2.9, 2.6, 2.3, 2.0],
      dmg:      [0, 0, 0, 0, 0],
      count:    [1, 1, 1, 2, 2],           // фонарей за раз
      lanternRadius: [92, 106, 120, 135, 152], lanternLife: [5, 5.5, 6, 6.5, 7],
      slow: 0.52, tickDmg: [3, 4, 5, 7, 9], tick: 0.4,
      evolveWith: 'vigor', evolveInto: 'lighthouse',
    },
    // Пепельник: чем меньше твой жар (ближе к холоду) — тем больнее бьёт
    duskblade: {
      name: 'Пепельник', desc: 'Нож из пепла: бьёт тем сильнее, чем меньше твой жар',
      icon: '†', color: '#c08bff', kind: 'bolt',
      cooldown: [0.9, 0.8, 0.7, 0.6, 0.5],
      dmg:      [16, 21, 27, 35, 46],
      count:    [1, 1, 2, 2, 3],
      speed: 560, pierce: 1, radius: 5, life: 0.9, knockback: 80, edgeBonus: 0.8,
      evolveWith: 'speed', evolveInto: 'eclipseblade',
    },
    // Рикошет: сгусток отскакивает от кромки тьмы и с каждым отскоком набирает жар
    ricochet: {
      name: 'Рикошет', desc: 'Сгусток скачет от кромки тьмы, набирая жар',
      icon: '⟁', color: '#ffd060', kind: 'ricochet',
      cooldown: [1.2, 1.05, 0.9, 0.78, 0.66],
      dmg:      [12, 16, 20, 26, 33],
      count:    [1, 1, 1, 2, 2],
      speed: 430, radius: 5, life: 3.0, bounces: [2, 2, 3, 3, 4], bounceGain: 0.25, knockback: 70,
      evolveWith: 'power', evolveInto: 'prism',
    },
    // Выброс: ульта — выброс жара по экрану + радиус вспыхивает до макс.
    dawnflash: {
      name: 'Выброс', desc: 'Ульта: выброс жара по экрану, радиус вспыхивает',
      icon: '☀', color: '#fff0a0', kind: 'nova',
      cooldown: [15, 14, 13, 12, 11],
      dmg:      [40, 55, 72, 92, 120],
      count:    [1, 1, 1, 1, 1],
      novaRadius: [260, 290, 320, 350, 390], knockback: 300, lightBurst: true,
      evolveWith: 'vigor', evolveInto: 'daybreak',
    },
  },

  // ---- Эволюции: макс. оружие (ур.5) + нужная пассивка → супер-оружие.
  // Появляются отдельной картой в драфте. Один уровень (массивы длины 1). ----
  evolutions: {
    dawnray: {
      name: 'Шквал', desc: 'Залп самонаводящихся искр, пробивает насквозь',
      icon: '☀', color: '#fff0a0', kind: 'bolt', base: 'bolt',
      cooldown: [0.22], dmg: [34], count: [5], speed: 660, pierce: 3, radius: 7, life: 1.4, knockback: 120,
    },
    corona: {
      name: 'Корона', desc: 'Кольцо сгустков жара вращается вокруг',
      icon: '❂', color: '#ffd27a', kind: 'orbit', base: 'orbit',
      cooldown: [0], dmg: [26], count: [6], orbitRadius: 98, orbitSpeed: 3.4, radius: 17, tick: 0.16, knockback: 90,
    },
    supernova: {
      name: 'Горение', desc: 'Опустошающая волна жара по всему экрану',
      icon: '✸', color: '#ffb060', kind: 'nova', base: 'nova',
      cooldown: [1.1], dmg: [58], count: [1], novaRadius: [270], knockback: 440,
    },
    solaredge: {
      name: 'Веер хлыста', desc: 'Рассекает во все стороны разом',
      icon: '✶', color: '#ffe066', kind: 'whip', base: 'whip',
      cooldown: [0.5], dmg: [50], count: [6], whipLen: [255], whipWide: 58, knockback: 160, radial: true,
    },
    tempest: {
      name: 'Пожар', desc: 'Огонь бьёт по всем рядом разом',
      icon: '☇', color: '#bfeaff', kind: 'chain', base: 'chain',
      cooldown: [0.45], dmg: [34], count: [8], hopRange: 215, firstRange: 380, knockback: 60,
    },
    beacon: {
      name: 'Угольное поле', desc: 'Поле взрывных углей-ловушек',
      icon: '❉', color: '#ffe066', kind: 'mine', base: 'mine',
      cooldown: [0.7], dmg: [58], count: [3], mineRadius: 98, mineLife: 5, mineTrigger: 60, knockback: 260,
    },
    sunlance: {
      name: 'Прожиг', desc: 'Широкий поток жара прожигает целый строй',
      icon: '⟱', color: '#ffe066', kind: 'beam', base: 'beam',
      cooldown: [0], dmg: [20], count: [2], beamLen: [460], beamWide: 24, tick: 0.09, knockback: 60,
    },
    lighthouse: {
      name: 'Жаровня', desc: 'Исполинская зона жара — крепость держит ночь',
      icon: '☀', color: '#ffe9a8', kind: 'lantern', base: 'lantern',
      cooldown: [1.6], dmg: [0], count: [2], lanternRadius: [205], lanternLife: [8.5],
      slow: 0.38, tickDmg: [15], tick: 0.3,
    },
    eclipseblade: {
      name: 'Пепельный веер', desc: 'Веер пепельных клинков прошивает строй',
      icon: '✠', color: '#c08060', kind: 'bolt', base: 'duskblade',
      cooldown: [0.36], dmg: [40], count: [4], speed: 640, pierce: 3, radius: 6, life: 1.0, knockback: 110, edgeBonus: 1.0,
    },
    prism: {
      name: 'Призма', desc: 'Поток дробится и рикошетит без устали',
      icon: '◈', color: '#bfeaff', kind: 'ricochet', base: 'ricochet',
      cooldown: [0.5], dmg: [30], count: [3], speed: 520, radius: 6, life: 3.5, bounces: [6], bounceGain: 0.3, knockback: 90,
    },
    daybreak: {
      name: 'Извержение', desc: 'Взрыв жара во весь экран ослепляет тьму',
      icon: '✺', color: '#ffe9a8', kind: 'nova', base: 'dawnflash',
      cooldown: [7], dmg: [150], count: [1], novaRadius: [460], knockback: 480, lightBurst: true,
    },
  },

  /* ---------------------------------------------------------------
     ГОРН-МОДЫ — «апгрейд апгрейда»: карта НЕ даёт уровень, а ветвит уже
     взятое оружие. Ставит флаг на объект оружия (w.<flag>=true), который
     боевой код читает in-situ (см. weapons.ts) — никакого агрегатного слоя.
     Появляется в драфте только когда выполнен prereq:
       weapon — ключ оружия (мод привязан к нему, не к kind);
       req.level — минимальный уровень оружия;
       need — flag предыдущего узла дерева (цепочка «апгрейд апгрейда»);
       excl — flag взаимоисключающей ветки (развилка: A ИЛИ B).
     Эффекты — чистые СТАТ-ТРАНСФОРМЫ (меняют ХАРАКТЕР билда, не «+N к числу»).
     RU-строки тут (fallback), перевод — data.forgeMods в en/de/fr.
     --------------------------------------------------------------- */
  forgeMods: {
    // Дерево «Импульса» (bolt): общий сердечник → развилка рой/строй
    bolt_core: {
      weapon: 'bolt', flag: 'fHotCore', req: { level: 2 },
      name: 'Раскалённый сердечник', desc: 'Импульс бьёт тяжелее (+35%) и пробивает 1 цель насквозь',
      icon: '✸', color: '#ff8a3a',
    },
    bolt_shrapnel: {
      weapon: 'bolt', flag: 'fShrapnel', req: { level: 3 }, need: 'fHotCore', excl: 'fArmor',
      name: 'Шрапнель', desc: 'Раскол на залп: +2 снаряда, но каждый бьёт мягче — ковёр огня',
      icon: '⁂', color: '#ffd27a',
    },
    bolt_armor: {
      weapon: 'bolt', flag: 'fArmor', req: { level: 3 }, need: 'fHotCore', excl: 'fShrapnel',
      name: 'Бронебой', desc: 'Один тяжёлый стержень: прошивает строй насквозь, но снарядов меньше',
      icon: '➶', color: '#c0683a',
    },
    // Дерево «Жар-сферы» (orbit): кольцо → развилка много орбов / один тяжёлый
    orbit_core: {
      weapon: 'orbit', flag: 'fOrbCore', req: { level: 2 },
      name: 'Раскалённое кольцо', desc: 'Сферы жарче (+30% урона) и кольцо шире — больше зона касания',
      icon: '◉', color: '#ffb35c',
    },
    orbit_swarm: {
      weapon: 'orbit', flag: 'fOrbSwarm', req: { level: 3 }, need: 'fOrbCore', excl: 'fOrbOne',
      name: 'Рой искр', desc: '+2 сферы, но каждая бьёт мягче — плотная карусель',
      icon: '◌', color: '#ffd27a',
    },
    orbit_one: {
      weapon: 'orbit', flag: 'fOrbOne', req: { level: 3 }, need: 'fOrbCore', excl: 'fOrbSwarm',
      name: 'Смерть одним', desc: 'На одну сферу меньше, зато тяжёлая: ×1.9 урона и крупнее',
      icon: '⬤', color: '#ff7a3a',
    },
    // Дерево «Хлыста» (whip): замах → развилка широкий размах / дальний гарпун
    whip_core: {
      weapon: 'whip', flag: 'fWhipCore', req: { level: 2 },
      name: 'Кованый замах', desc: 'Удар тяжелее (+30%) и сильнее отбрасывает',
      icon: '⟿', color: '#ffd24a',
    },
    whip_sweep: {
      weapon: 'whip', flag: 'fWhipSweep', req: { level: 3 }, need: 'fWhipCore', excl: 'fWhipHarpoon',
      name: 'Размах', desc: 'Дуга шире на 70% и вдвое сильнее сметает — контроль толпы, мягче на цель',
      icon: '〜', color: '#ffe066',
    },
    whip_harpoon: {
      weapon: 'whip', flag: 'fWhipHarpoon', req: { level: 3 }, need: 'fWhipCore', excl: 'fWhipSweep',
      name: 'Гарпун', desc: 'Длинное узкое копьё: бьёт вдвое дальше и тяжелее, но тонкой полосой',
      icon: '➳', color: '#ffb35c',
    },
    // ПОВЕДЕНЧЕСКИЕ КАПСТОУНЫ (3-й тир: новые ГЛАГОЛЫ оружия, не стат — переиспользуют существующие
    // хуки снарядов/knockback, без новых систем). Gate: core-узел дерева + req.level 4.
    bolt_split: {
      weapon: 'bolt', flag: 'fSplit', req: { level: 4 }, need: 'fHotCore',
      name: 'Раскол на лету', desc: 'При попадании Импульс раскалывается на 2 самонаводящихся осколка',
      icon: '⋔', color: '#ff9a4a',
    },
    whip_grasp: {
      weapon: 'whip', flag: 'fWhipGrasp', req: { level: 4 }, need: 'fWhipCore',
      name: 'Захват', desc: 'Хлыст не отбрасывает, а ТЯНЕТ тварей в жар-границу — на расправу теплом',
      icon: '⟜', color: '#ffb35c',
    },
  },

  /* ---------------------------------------------------------------
     ОВЕРКЛОК (горн-класс B) — «апгрейд того, что уже закончилось»: снятие капа
     МАКСНУТОГО оружия (ур.5 или эволюция) ценой СВЕТА. Каждый стак: +урон и
     −кулдаун оружию, но сужает moat света (цель −lightCost за стак) → дрейф к
     ТЁМНОМУ полюсу оси. Это оживляет билд-ось: жжёшь свой свет за мощь, ранняя
     выплата loEdge, duskblade/синергии тьмы. Risk/reward. Магнитуды — тюнинг владельцу.
     --------------------------------------------------------------- */
  // maxDrain — потолок суммарного дрейфа света от всех оверклоков: мульти-оверклок не должен
  // залочить свет на min навсегда (иначе ось перестаёт реагировать на уровень/убийства).
  overclock: { maxStacks: 3, dmgPerStack: 0.22, firePerStack: 0.06, lightCost: 28, maxDrain: 120 },

  // ПРИМАНКА — активный ГЛАГОЛ света: зажми клавишу, гаси свою сферу (свет к min) → враги вне света
  // роятся быстрее/плотнее (darkSpeedMult), а тёмный полюс (loEdge) на пике. Через holdTime удержания
  // срывается burst-вспышкой жара (очистка толпы + частичный возврат света). Цена: в гашении уязвим
  // (нет heat-killzone, толпа близко). «Я свет, притворившийся тьмой». Магнитуды — тюнинг владельцу.
  lure: { key: 'f', drainMul: 5, holdTime: 1.4, cooldown: 4, burstRadiusMul: 1.2, burstDmg: 34, burstKb: 320, burstLight: 280 },

  // ---- Пассивки (lvl 1..5) ----
  // stat-пассивки (mode mult/add/addMaxHp) обрабатываются в Player.recalc по def.stat.
  // special-пассивки (mode 'special') дают БИЛДОВЫЙ эффект — их производные поля
  // считаются в recalc отдельным проходом и читаются в боевых хуках (см. game.ts).
  passives: {
    speed:  { name: 'Ускорение', desc: '+скорость движения', icon: '➤', color: '#5ef2ff',
              stat: 'moveSpeed', mode: 'mult', val: [1.10, 1.18, 1.26, 1.34, 1.42] },
    power:  { name: 'Мощь', desc: '+весь урон', icon: '✸', color: '#ff7a5c',
              stat: 'damageMult', mode: 'mult', val: [1.12, 1.24, 1.36, 1.50, 1.66] },
    regen:  { name: 'Регенерация', desc: '+восстановление HP', icon: '✚', color: '#7CFFB2',
              stat: 'regen', mode: 'add', val: [0.3, 0.6, 0.9, 1.3, 1.8] },
    magnet: { name: 'Магнит', desc: '+радиус подбора', icon: '◎', color: '#ffd24a',
              stat: 'pickupRadius', mode: 'mult', val: [1.4, 1.8, 2.3, 2.9, 3.6] },
    vigor:  { name: 'Стойкость', desc: '+макс. HP', icon: '❤', color: '#ff4d6d',
              stat: 'maxHp', mode: 'addMaxHp', val: [25, 50, 80, 115, 155] },
    // --- билдовые (special) ---
    // Точность: шанс крит-удара (×2.2 урона), читается в Game.hitEnemy
    crit:   { name: 'Точность', desc: 'Шанс крит. удара (×2.2)', icon: '✷', color: '#ffe066',
              mode: 'special', special: 'crit', val: [0.08, 0.14, 0.20, 0.27, 0.36] },
    // Скорострельность: множитель кулдауна всего оружия (читается в Weapons.update)
    haste:  { name: 'Скорострельность', desc: '−кулдаун всего оружия', icon: '⏿', color: '#9fd8ff',
              mode: 'special', special: 'haste', val: [0.91, 0.83, 0.76, 0.69, 0.62] },
    // Жатва жара: лечит HP за каждое убийство (читается в Game.killEnemy)
    leech:  { name: 'Жатва жара', desc: 'Лечит HP за убийство', icon: '❥', color: '#7CFFB2',
              mode: 'special', special: 'leech', val: [0.2, 0.35, 0.55, 0.8, 1.1] },
    // Вспышка: убитый враг взрывается, урон по площади (цепная реакция; Game.killEnemy)
    bloom:  { name: 'Вспышка', desc: 'Убитые взрываются жаром', icon: '❉', color: '#ff9040',
              mode: 'special', special: 'bloom', val: [9, 15, 23, 33, 47], radius: [54, 60, 68, 76, 86] },
    // Иней: аура вокруг тебя замедляет врагов (читается в Game.updateEnemies)
    frost:  { name: 'Иней', desc: 'Аура замедляет тьму вокруг', icon: '❆', color: '#bfeaff',
              mode: 'special', special: 'frost', val: [0.82, 0.74, 0.66, 0.58, 0.48], radius: [120, 140, 160, 180, 205] },
    // Жаркий пульс: при ударе по тебе — волна отбрасывает и жжёт врагов рядом
    pulse:  { name: 'Жаркий пульс', desc: 'Удар по тебе → волна жара', icon: '◉', color: '#fff0a0',
              mode: 'special', special: 'pulse', val: [16, 26, 40, 58, 80], radius: [120, 140, 165, 195, 230] },
  },

  /* ---------------------------------------------------------------
     РЕЛИКВИИ — перм-эффекты на забег, награда Святилищ (точки интереса
     в пространстве). Дают мотивацию УЙТИ от роя и добежать до света вдали.
     Эффект применяется через Game.applyRelic — мутирует базу игрока + recalc,
     либо ставит флаг, читаемый боевыми хуками. Можно собрать несколько за забег.
     --------------------------------------------------------------- */
  relics: {
    ember:    { name: 'Уголь Зари',     desc: '+22% урона навсегда',           icon: '✸', color: '#ff7a5c', dmg: 1.22 },
    bulwark:  { name: 'Бастион',        desc: '+45 макс. HP, +0.8 HP/сек',     icon: '❤', color: '#ff4d6d', maxHp: 45, regen: 0.8 },
    swift:    { name: 'Скороход',       desc: '+14% скорости, ×1.8 магнит',    icon: '➤', color: '#5ef2ff', speed: 1.14, magnet: 1.8 },
    radiance: { name: 'Сияние',         desc: '+90 радиус жара',               icon: '☀', color: '#ffce5e', light: 90 },
    overload: { name: 'Перегруз',       desc: 'Оружие бьёт на 18% чаще',       icon: '⏿', color: '#9fd8ff', cdMul: 0.82 },
    famine:   { name: 'Жажда',          desc: 'Лечит 0.9 HP за убийство',      icon: '❥', color: '#7CFFB2', leech: 0.9 },
    thorns:   { name: 'Венец гнева',    desc: 'Жар постоянно жжёт врагов вокруг', icon: '✺', color: '#e87840', aura: 1 },
    greed:    { name: 'Алчность',       desc: '×1.6 золота до конца забега',   icon: '◆', color: '#ffd24a', gold: 1.6 },
    // --- БИЛД-ОСЬ ГРАНИЦЫ (свет как ось выбора билда): реликвии тёмного/светлого полюса ---
    umbralward: { name: 'Ярость углей',  desc: 'Чем ниже жар, тем злее удар: до +60% урона во тьме', icon: '†', color: '#b5683a', loEdge: 0.6 },
    dawncrown:  { name: 'Венец зари',    desc: 'Чем шире жар, тем сильнее удар: до +45% урона в свете', icon: '☀', color: '#ffd98a', hiEdge: 0.45 },
  },

  /* ---------------------------------------------------------------
     СИНЕРГИИ ОРУЖИЯ — выжимка комбинаторики билд-оси (R2). Когда у игрока ОБА оружия пары,
     активируется именованная синергия. Чистая рекомбинация существующих примитивов:
     edge:'lo' добавляет к тёмному полюсу (_synLo, окупается при НИЗКОМ жаре),
     edge:'hi' — к светлому (_synHi, при ШИРОКОМ), edge:null — ровный множитель урона.
     Считается в Player.recalc(); _synLo/_synHi суммируются с реликвийным _loEdge/_hiEdge в Weapons._dmg.
     Тематика по полюсам: стакаешь «свой» полюс оружием — растёшь сильнее (награда за фокус билда).
     Магнитуды (amount) — вкус баланса, на тюнинг владельцу (как HG-23).
     --------------------------------------------------------------- */
  synergies: [
    // ТЁМНЫЙ ПОЛЮС: пары «пепельных» оружий — ярость во тьме
    { key: 'ashEcho',      a: 'duskblade', b: 'ricochet',  name: 'Эхо пепла',      icon: '†', edge: 'lo',  amount: 0.25 },
    { key: 'darkForge',    a: 'duskblade', b: 'lantern',   name: 'Кузня тьмы',     icon: '†', edge: 'lo',  amount: 0.22 },
    { key: 'smolderfield', a: 'mine',      b: 'lantern',   name: 'Тлеющее поле',   icon: '†', edge: 'lo',  amount: 0.20 },
    // СВЕТЛЫЙ ПОЛЮС: пары оружий «широкого жара» — мощь в свете
    { key: 'sunPillar',    a: 'beam',      b: 'nova',      name: 'Солнечный столб', icon: '☀', edge: 'hi', amount: 0.22 },
    { key: 'heatCorona',   a: 'orbit',     b: 'beam',      name: 'Корона жара',    icon: '☀', edge: 'hi',  amount: 0.20 },
    { key: 'dawnSalvo',    a: 'bolt',      b: 'dawnflash', name: 'Залп зари',      icon: '☀', edge: 'hi',  amount: 0.18 },
    // НЕЙТРАЛЬНАЯ: ровный бонус урона
    { key: 'fireWhirl',    a: 'chain',     b: 'whip',      name: 'Огненный вихрь', icon: '✺', edge: null,  amount: 0.14 },
  ],

  // ---- Святилища: типы точек интереса (награда за поход к свету вдали) ----
  // relic — выбор из 3 реликвий; cache — щедрое золото + всплеск света; font — лечение + временный мощный баф.
  shrines: {
    spawnEvery: 32,          // как часто появляется новое святилище, сек (26→32: дистанция выросла — пусть не спамит карту)
    maxActive: 3,            // сколько одновременно «горит» в мире
    minDist: 1400,           // не ближе этого к игроку (560→1400: поход к точке = мини-приключение через толпы, не 10 секунд бега)
    maxDist: 2600,           // и не дальше (1150→2600: при 178 px/с — 8–15 с чистого бега, с боем и манёврами 20–40 с)
    radius: 30,              // радиус активации (подходишь — срабатывает)
    blessLife: 18,           // длительность временного бафа (font), сек
    kinds: [
      { key: 'relic', name: 'Святилище', icon: '✦', color: '#ffe066', weight: 1.0 },
      { key: 'cache', name: 'Тайник',    icon: '◆', color: '#ffd24a', weight: 1.3 },
      { key: 'font',  name: 'Источник',  icon: '✚', color: '#7CFFB2', weight: 1.1 },
      // ТЕНЁТА (TD-захват): точка хватает героя — он обездвижен и ДЕРЖИТСЯ snareDur секунд под наплывом,
      // выбрав одну способность на это окно. Выстоял → крупная награда. Новый глагол «держись» (не «убегай»).
      { key: 'snare', name: 'Тенёта',    icon: '✸', color: '#c75b6a', weight: 0.8 },
    ],
  },

  /* ---------------------------------------------------------------
     TD-ЗАХВАТ (Тенёта) — позиционный момент: точка-очаг открывает ЗОНУ розжига. Игрок МОБИЛЕН
     внутри зоны (не корень — слой A снял обездвиживание): держишься рядом с точкой → бар розжига
     (kindle) растёт; вышел увернуться → медленно спадает; враги в зоне замедляют розжиг (контест).
     Рой стягивается к точке (capture-давление) + спавн гуще. Полный розжиг (kindle=1) → ранняя
     вспышка-успех; иначе окно snareT истекает → успех всё равно, награда масштабируется достигнутым
     розжигом (инвариант «всегда успех», провала нет — только смерть). Глубже kindleRate ниже →
     дольше держать. Игрок выбирает опору-бун на окно. Полюс: светлый держит зону ШИРЕ, тёмный — ЗЛЕЕ.
     --------------------------------------------------------------- */
  snare: {
    minTime: 200,            // Тенёта появляется только с 3:20 — раннее удержание на слабом билде несправедливо
    dur: 11,                 // макс окно удержания, сек (8→11: корень снят, игрок мобилен — длиннее не против жанра; ранний розжиг завершает быстрее)
    zoneRadius: 280,         // радиус зоны розжига — держись рядом с точкой (мобилен внутри), вне — розжиг спадает
    kindleRate: 0.13,        // прирост розжига/сек в зоне (≈7.7с чистого удержания до полного; враги замедляют)
    kindleDecay: 0.06,       // спад розжига/сек вне зоны (вышел увернуться → теряешь прогресс, но не мгновенно)
    enemySlow: 0.045,        // каждый враг в зоне замедляет розжиг на эту долю (контест плотностью)
    slowFloor: 0.3,          // ...но не ниже 30% базовой скорости — никогда не залочить розжиг полностью
    depthRateMul: 0.14,      // глубже → kindleRate ниже (rate / (1+depth*это)) → дольше держать (вариант A менеджера)
    pullRadius: 520,         // радиус стягивания роя к точке во время захвата
    pullForce: 90,           // сила подтягивания врагов (px/с² к центру) — давление, не телепорт
    spawnBoost: 1.6,         // во сколько раз гуще спавн волн во время захвата
    lightWide: 80,           // +радиус света светлому полюсу (hiEdge) на время захвата
    darkDmg: 0.3,            // +доля урона тёмному полюсу (loEdge) на время захвата
    rewardGold: 60,          // базовое золото за полное удержание (масштабируется розжигом и глубиной)
    rewardLight: 220,        // базовый всплеск света на выходе
    rewardGems: 5,           // базовые крупные осколки опыта за удержание
    rewardFloor: 0.45,       // даже слабое удержание даёт эту долю награды (щедрость инварианта «всегда успех»)
    depthRewardMul: 0.25,    // награда растёт с глубиной (1 + depth*это)
    // АРХЕТИПЫ TD-точки (выбор при срабатывании, без повтора подряд; первая в забеге — всегда kindle, мягкий онбординг):
    //   kindle — «Разжечь» (слой A): держи зону, бар розжига; провала нет.
    //   defend — «Оборона» (слой B): защити ядро-очаг с целостностью от стянутого роя; ядро погибло → ПРОВАЛ (ноль награды).
    archetypes: ['kindle', 'defend'],
    defend: {
      coreHp: 220,           // целостность ядра-очага (фиксирована на всех глубинах — инвариант «пассивность=провал» держится везде)
      coreHitRadius: 90,     // в этом радиусе враги бьют ядро — держи его чистым
      coreDpsPerEnemy: 5,    // урон ядру/сек от ОДНОГО врага в радиусе (контест плотностью)
      coreDamageCap: 30,     // ...но суммарный входящий урон ограничен (сглаживание спайка: 220/30≈7.3с uncontested < окна 11с)
      pullForce: 200,        // СИЛЬНЕЕ базового (90): рой стянут на ядро доминантно → защита настоящая, не убежать-сбросить
      failHpLoss: 0.67,      // ПРОВАЛ обороны снимает эту долю ТЕКУЩЕГО HP игрока (×0.33, пол 1) — больно, но НЕ смертельно
      // ПРОТОТИП «свет-маятник»: в обороне ставишь УГЛИ — копии своих оружий стационарно (клавиша E).
      // Уголёк стреляет из своей точки + светит в радиусе emberRadius (моат «ты=свет»: работает в своём свете).
      emberKinds: ['bolt', 'chain', 'lantern'],   // какие оружия билда можно поставить углём (точечный/цепной/зональный)
      emberRadius: 190,      // радиус «работы/света» угля — bolt-уголёк видит цели только тут (ты=свет в статике)
      emberMaxBudget: 6,     // потолок углей за стадию (по факту ограничен числом поддерживаемых оружий в билде)
      // СВЕТ-МАЯТНИК слой 1: оборона = многоволновая TD-стадия (не одно окно). Волна → ПАУЗА (ставь/перекрывай угли) → волна.
      // Выстоял все волны с живым ядром → успех. Обычный спавнер заглушён на стадии (волны = весь спавн, чистая эскалация).
      waves: 3,              // сколько волн в стадии
      waveDur: 9,            // длительность боевой фазы волны, сек
      waveGap: 4,            // пауза между волнами, сек (передышка на расстановку углей — TD-ритм)
      waveBaseCount: 10,     // врагов в 1-й волне
      waveGrowth: 6,         // +врагов на каждую следующую волну (эскалация: 10 / 16 / 22)
      forceEntry: false,     // вход в стадию: false=опциональный (заходишь сам, player-paced); true=принудительный маятник (задел)
    },
    // СПОСОБНОСТИ-ОПОРЫ (выбор одной на окно захвата). Эффект только пока длится захват.
    boons: [
      { key: 'bulwark',  name: 'Бастион',  desc: '−55% входящего урона на удержании',  icon: '❤', color: '#ff8a5c', dr: 0.55 },
      { key: 'overheat', name: 'Перегрев', desc: 'Оружие бьёт ×2 чаще, +25% урона',    icon: '⏿', color: '#ffce5e', cdMul: 0.5, dmg: 1.25 },
      { key: 'pulsar',   name: 'Пульсар',  desc: 'Волны жара отбрасывают и жгут рой',  icon: '◉', color: '#fff0a0', pulseCd: 0.9, pulseDmg: 34, pulseR: 200, pulseKb: 360 },
    ],
  },

  // ---- Juice / feel ----
  feel: {
    shakeOnHit: 5,
    shakeOnNova: 7,
    shakeOnBossDeath: 22,
    shakeDecay: 9,
    hitFlash: 0.09,
    dmgNumberLife: 0.7,
    deathParticles: 7,
    bossDeathParticles: 60,
  },
};
